import { render, staticRenderFns } from "./ExportOld.vue?vue&type=template&id=d5e61170"
import script from "./ExportOld.vue?vue&type=script&lang=js"
export * from "./ExportOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports